import gql from 'graphql-tag';

export default gql`
  query customAuthToken($accessToken: String!) {
    customAuthToken(accessToken: $accessToken)
  }
`;
